let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ldaqr")).then(() => parcelRequire('2LEbU'));